import React, { useState } from 'react';
import Login from '@pages/Register/Login';
import SignUp from '@pages/Register/SignUp';
import styled from 'styled-components';
import MainLogo from '@components/navigation/MainLogo';
import { fuego, useDocument } from '@nandorojo/swr-firestore';
import { IgatePageSet } from '@typings/pages/gatePage.interface';
import { CollectionPath, ImainhomeDoc } from '@typings/collections.enum';
import Button from '@components/dataEntry/button/Button';
import { motion } from 'framer-motion';
import { useRecoilState } from 'recoil';
import { gatePageActiveState } from '@atom/setting/homepageSet';
import MainEffect from '@app/options/BackgroundEffect';
import useValidLogin from '@hooks/useValidLogin';
import ServiceFooter from '@components/navigation/Footer/ServiceFooter';
import { scrollbarStyle } from '@styles/variants/scrollbar';

const Container = styled(motion.div)`
  width: 100vw;
  height: 100dvh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  overflow-y: auto;
  overflow-x: hidden;

  background: center / cover no-repeat;

  ${scrollbarStyle}
  @media (max-width: 480px) {
    padding-top: 0px;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 360px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media (max-width: 480px) {
    padding: 0;
    img {
      max-width: 100%;
    }
  }
`;

const variants = {
  hidden: { opacity: 0, y: 50 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 1.6,
    },
  },
  exit: {
    opacity: 0,
    y: -50,
    transition: {
      ease: 'easeInOut',
      duration: 0.8,
    },
  },
};

const FooterSec = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
`;

type Props = {};
function GatePage({}: Props) {
  const [isLoginPage, setIsLoginPage] = useState(true);
  const isValidLogin = useValidLogin();

  const [gatePageActive, setGatePageActive] =
    useRecoilState(gatePageActiveState);

  function toggleLogin() {
    setIsLoginPage(!isLoginPage);
  }
  const { data: gatePageSet } = useDocument<IgatePageSet>(
    `${CollectionPath.MAINHOME}/${ImainhomeDoc.GATEPAGE}`,
    { listen: true },
  );

  const LoginPage = () => {
    return (
      <>
        {isLoginPage ? (
          <Login setTitle={false} toggleLogin={toggleLogin} />
        ) : (
          <SignUp setTitle={false} toggleLogin={toggleLogin} />
        )}
      </>
    );
  };

  if (isValidLogin) return null;

  return (
    <Container
      variants={variants}
      initial="hidden"
      animate="show"
      exit="exit"
      style={{ backgroundImage: `url("${gatePageSet?.gateBackgroundImg}")` }}
    >
      <Wrapper>
        {gatePageSet && gatePageSet?.gateLogo ? (
          <img src={gatePageSet?.gateLogo} alt="홈페이지 대문 로고" />
        ) : (
          <>{/* <MainLogo style={{ height: 'auto' }} /> */}</>
        )}

        {gatePageSet && gatePageSet?.setLogin ? (
          <LoginPage />
        ) : (
          <Button onClick={() => setGatePageActive(false)}>
            {gatePageSet?.startText || '시작하기'}
          </Button>
        )}
      </Wrapper>
      <MainEffect />

      <FooterSec>
        <ServiceFooter />
      </FooterSec>
    </Container>
  );
}

export default GatePage;
